import {defineStore} from 'pinia'
import {config} from "@/core/config";
import {SmartSearchConfig} from "@/main";


export const usePopularProductsStore = defineStore('PopularProductsStore', {
  state: () => {
    return {
      popularProducts: [],
      
    }
  },
  getters: {
    getTopProduct(state){
      return state.popularProducts[0]
    },
    getPopularProducts(state) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return state.popularProducts.slice(0, SmartSearchConfig.value.onfocus.popularProducts.count)
    },
    getPopularProductsWithoutFirst(state) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return state.popularProducts.slice(1, SmartSearchConfig.value.onfocus.popularProducts.count + 1)
    }
  },
  actions: {
    // getPopularProductsFromSessionStorage(){
    //
    // },
    async fetchPopularProducts() {
      const data = new FormData()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      data.append('s', SmartSearchConfig.value.onfocus.popularProducts.sortName)
      
      try {
        const response = await fetch(
            `https://${config.apiHost}/restapi/${config.customerSymbol}/search/${config.searchId}/products`,
            {
              method: 'POST',
              headers: {
                'Api-key': config.apiKey,
              },
              credentials: 'include',
              body: data,
            }
        )
        
        if (response.ok) {
          const data = await response.json()
          const {products} = data
          this.popularProducts = products
        }
      } catch (error) {
        console.error('Error retrieving search results:', error)
      }
    }
    
  },
})